import {
  SET_PRODUCTION_STATUS_AUTHORS_FILTER,
  SET_PRODUCTION_STATUS_COURSE_FILTER,
  SET_PRODUCTION_STATUS_LEVELS_FILTER,
  SET_PRODUCTION_STATUS_TAG_FILTERS,
  SET_PRODUCTION_STATUS_PRIMARY_SUBJECT_FILTER,
  SET_PRODUCTION_STATUS_ASSIGNED_TO_FILTERS,
  SET_PRODUCTION_STATUS_TARGET_GRADE_LEVEL_FILTERS,
  CLEAR_PRODUCTION_STATUS_FILTERS
} from '../actions/productionstatusfilters'

export const initialState = {
  authors_id_in: [],
  questtags_id_in: [],
  quest_subject_id_in: [],
  assigned_to_id_in: [],
  grade_levels_id_in: [],
  mock_course_id_in: null,
  mock_level_id_in: []
}

export function productionstatusfilters(state = initialState, action) {
  switch (action.type) {
    case SET_PRODUCTION_STATUS_AUTHORS_FILTER:
      return Object.assign({}, state, {
        authors_id_in: action.authors_id_in
      })
    case SET_PRODUCTION_STATUS_COURSE_FILTER:
      return Object.assign({}, state, {
        mock_course_id_in: action.mock_course_id_in,
        mock_level_id_in: []
      })
    case SET_PRODUCTION_STATUS_LEVELS_FILTER:
      return Object.assign({}, state, {
        mock_level_id_in: action.mock_level_id_in
      })
    case SET_PRODUCTION_STATUS_TAG_FILTERS:
      return Object.assign({}, state, {
        questtags_id_in: action.questtags_id_in
      })
    case SET_PRODUCTION_STATUS_PRIMARY_SUBJECT_FILTER:
      return Object.assign({}, state, {
        quest_subject_id_in: action.quest_subject_id_in
      })
    case SET_PRODUCTION_STATUS_ASSIGNED_TO_FILTERS:
      return Object.assign({}, state, {
        assigned_to_id_in: action.assigned_to_id_in
      })
    case SET_PRODUCTION_STATUS_TARGET_GRADE_LEVEL_FILTERS:
      return Object.assign({}, state, {
        grade_levels_id_in: action.grade_levels_id_in
      })
    case CLEAR_PRODUCTION_STATUS_FILTERS:
      return Object.assign({}, state, initialState)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/productionstatusfilters.js